import { LocalSessionKey } from 'app/constants/app-constants';
import MobileOtpLogin from 'app/container/Login/MobileOtpLogin';
import PageNotFound from 'app/container/PageNotFound'; // Assuming you have a PageNotFound component
import { LocalStorage } from 'app/utils/storage';
import { Outlet } from 'react-router-dom';
import BasePage from './BasePage';

const RoleBasedRoute = ({ requiredRole }) => {
  const token = localStorage.getItem('accessToken');
  const newauth = token && typeof token === 'string';
  const user = JSON.parse(LocalStorage.get(LocalSessionKey.USER_INFO));
  if (!newauth) {
    return <MobileOtpLogin />;
  }

  if (!requiredRole.includes(user?.type)) {
    return <PageNotFound />;
  }

  return (
    <BasePage>
      <Outlet />
    </BasePage>
  );
};

export default RoleBasedRoute;
